import { LogOutSquareIcon } from '../../../../../assets/icons/common';
import { toTime } from '../../../../../utils/generalHelpers';
import Button from '../../../../../components/Button';
import { CurrentQuestion } from '../../types';
import styles from './style.module.scss';

interface Props {
    counter: number;
    loading: boolean;
    onNext: () => void;
    onExit: () => void;
    question: CurrentQuestion;
};

/** The question on display, the time left to answer it, and the way out of the interview. */
function QuestionPanel(props: Props) {
    const {
        onNext,
        onExit,
        counter,
        loading,
        question,
    } = props;

    const { minutes, seconds } = toTime(counter);

    return (
        <div className={styles.question_box}>
            <div className={styles.header}>
                <div className={styles.header_question_count}>
                    {`${question.number} / ${question.total}`}
                </div>
                <div className={styles.header_exit} onClick={onExit}>
                    <LogOutSquareIcon />
                    <span>Exit exam</span>
                </div>
            </div>
            <span className={styles.question_box_text}>
                {question.number}. {question.text}
            </span>
            <div className={styles.extra}>
                <div className={styles.extra_countdown}>
                    <div className={styles.extra_countdown_numb}>
                        <span>{minutes}</span>
                        <span>Minutes</span>
                    </div>
                    <span className={styles.extra_countdown_divider}>:</span>
                    <div className={styles.extra_countdown_numb}>
                        <span data-is-color-primary="true">{seconds}</span>
                        <span>Seconds</span>
                    </div>
                </div>
                <Button
                    type='Primary'
                    onClick={onNext}
                    loading={loading}
                    text='Next question'
                    className={styles.extra_btn}
                />
            </div>
        </div>
    )
};

export default QuestionPanel;
